import IdNameDto from '@src/adapters/dto/shared/IdNameDto';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  filter: String;
}

interface Result {
  items: IdNameDto[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/manufacturer/for_selection/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindManufacturersForSelection = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useFindManufacturersForSelectionLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindManufacturersForSelection;
